import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import RequestsByMonthByUploadingUserList from './components/month/RequestsByMonthListByUploadingUser';
import RequestsByWeekByUploadingUserList from './components/week/RequestsByWeekListByUploadingUser';

function RequestsByUploadingUser() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Requests by uploading user"
      MonthList={RequestsByMonthByUploadingUserList}
      WeekList={RequestsByWeekByUploadingUserList}
    />
  );
}

export default RequestsByUploadingUser;
